import { NewCasinoGamesFetchingParams } from 'interfaces/new-casino';

export enum CasinoGamesFetchingParamsActionType {
  SET = 'SET_FETCHING_PARAMS',
  RESET = 'RESET_FETCHING_PARAMS'
}

export const casinoGamesFetchingParamsReducer = (
  state: Partial<NewCasinoGamesFetchingParams>,
  action: {
    type: CasinoGamesFetchingParamsActionType;
    payload?: Partial<NewCasinoGamesFetchingParams>;
  }
): Partial<NewCasinoGamesFetchingParams> => {
  const { type, payload } = action;

  switch (type) {
    case CasinoGamesFetchingParamsActionType.SET:
      return { ...state, ...payload };
    case CasinoGamesFetchingParamsActionType.RESET:
      return {};
    default:
      return state;
  }
};
